/* CRO 2026-09-22. Buy box presentation, kept out of sections/kc3-buybox.liquid
   and assets/kc3.js on purpose: both are shared with the live theme and both
   are large, and a display-only experiment should not need either rewritten.

   Most of this is cosmetic and cannot break a sale: if it throws, the buy box
   looks the way it did before. The ONE exception is the DoorMate add-in, which
   appends a line to `.kc3-buy[data-cards]` and therefore does reach the cart.
   It never touches the camera variant id or the quantity, and it re-reads
   kc3.js's own total before adding its price, so an unticked box always leaves
   the payload and the displayed total exactly as kc3.js computed them.

   Copy: the strings below are the same settings a merchant can set in the
   theme editor (tier_label, tier_hint, addon_title). Each rewrite only fires
   when it still finds the old default, so setting the real section setting
   makes the corresponding rewrite here a no-op rather than a fight. */
(function () {
  if (window.KC3_TIER_SAVINGS) return;
  window.KC3_TIER_SAVINGS = true;

  /* Which tier should carry "Most popular". Set to 0 to leave the tag wherever
     the tiers JSON put it. */
  var PROMOTE_Q = 3;

  var TIER_LABEL = 'Limited-time bundle deals';
  var ADDON_HEAD = 'Add to your order';
  var ADDON_TITLE = 'Micro TF card — one per camera';

  /* Whole dollars both ways, but rounded in opposite directions on purpose.
     A total rounds UP so the tile can never quote less than the cart charges,
     and a saving rounds DOWN so it can never overstate what is kept. Both
     errors land under a dollar, and both land in the customer's favour. */
  function moneyUp(n) { return '$' + Math.ceil(n).toLocaleString('en-AU'); }
  function moneyDown(n) { return '$' + Math.floor(n).toLocaleString('en-AU'); }

  /* The DoorMate add-in. kc3.js builds the cart from `.kc3-buy[data-cards]`
     (see lineItems() in assets/kc3.js) and re-writes that attribute, #ctaAmt
     and the sticky bar together on every sync, ending with a bubbling
     `kc3:selection`. So this hangs off that event rather than patching fetch:
     we let kc3.js finish, then put our line back and re-add our price.

     dmBase is kc3.js's own total, captured the moment it publishes it and
     before we touch it, so ticking and unticking is never cumulative. */
  /* The add-in catalogue.

     `pay` is the price at EIGHT per cent, not ten, and it is a floor rather
     than a fixed offer. The add-in is not a separate deal -- it is one more
     device, so it lands on the same shared ladder as everything else in the
     cart. Ticking it next to a single camera makes two devices, which is the
     8% rung, and 8% comes off BOTH. Tick it next to two cameras and the cart
     is three devices at 10%, off all three. The more they have, the cheaper
     this line gets.

     So the price is shown as "from", and the ribbon says "or more". The cart
     can only ever beat what is on screen here, never fall short of it -- the
     safe direction to be wrong in.

     Flat dollars again so the percentage floors cleanly: $24 off $299 is
     8.03% and $27 off $329 is 8.21%, both quoted as 8%. */
  var ADDINS = {
    doormate: {
      id: 51416958566674,
      list: 299,
      pay: 275,
      title: 'KeldCo DoorMate Doorbell Camera Wifi',
      label: 'Add a DoorMate video doorbell',
      img: 'https://cdn.shopify.com/s/files/1/0534/5761/7046/files/main_picture_2_200x.png?v=1753134381'
    },
    sc3: {
      id: 51761813946642,
      list: 329,
      pay: 302,
      title: 'Solar Camera Pro 3.0 WIFI\u00ae',
      label: 'Add a Solar Cam Pro 3.0',
      img: 'https://cdn.shopify.com/s/files/1/0534/5761/7046/files/Untitleddesign_97_200x.png?v=1765187764'
    }
  };

  /* Which add-in each product offers, first match wins. A null means the
     product offers none -- the 4G is deliberately on its own, because its
     buyer is covering a place with no Wi-Fi and neither a doorbell nor a
     Wi-Fi camera would work there.

     Never offer a product as an add-in to itself. The DoorMate rule below
     sits after the SC3 rule for that reason: read them as a pair. */
  var ADDIN_FOR = [
    [/\b4g\b/i,             null],
    [/solar camera pro 3/i,  'doormate'],
    [/doormate/i,            'sc3'],
    [/home guardian/i,       'doormate'],
    [/lumis/i,               'doormate']
  ];

  function addinFor(title) {
    for (var i = 0; i < ADDIN_FOR.length; i++) {
      if (ADDIN_FOR[i][0].test(title)) {
        var key = ADDIN_FOR[i][1];
        return key ? ADDINS[key] : null;
      }
    }
    return null;
  }

  /* Resolved once per page in buildAddons, then read by applyAddin. */
  var ADDIN = null;
  var dmBase = null;

  function fmt(n) {
    return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function parseAmt(t) {
    var n = parseFloat(String(t || '').replace(/[^0-9.]/g, ''));
    return isFinite(n) ? n : null;
  }

  function applyAddin(root) {
    if (!root || !ADDIN) return;
    var buy = root.querySelector('.kc3-buy');
    var cb = root.querySelector('#kcDmCb');
    if (!buy || !cb) return;
    var on = cb.checked;

    var cards = [];
    try { cards = JSON.parse(buy.dataset.cards || '[]'); } catch (e) { cards = []; }
    cards = cards.filter(function (c) { return Number(c.id) !== ADDIN.id; });
    if (on) cards.push({ id: ADDIN.id, quantity: 1, price: ADDIN.pay, title: ADDIN.title });
    buy.dataset.cards = JSON.stringify(cards);

    var amtEl = root.querySelector('#ctaAmt');
    if (dmBase === null) dmBase = parseAmt(amtEl && amtEl.textContent);
    if (dmBase === null) return;

    var total = dmBase + (on ? ADDIN.pay : 0);
    if (amtEl) amtEl.textContent = fmt(total);
    var sb = document.querySelector('#stickyBtn');
    if (sb) sb.textContent = 'Add to cart \u00b7 ' + fmt(total);
    var ss = document.querySelector('#stickySub');
    if (ss) ss.textContent = (ss.textContent || '').replace(/\$[\d,]+\.\d{2}\s*$/, fmt(total));
  }

  function buildAddin(root, wrap, afterEl) {
    if (root.querySelector('#kcDm')) return;

    var label = document.createElement('label');
    label.className = 'addon kc3-addon--dm';
    label.id = 'kcDm';

    var cb = document.createElement('input');
    cb.type = 'checkbox'; cb.className = 'sr-only'; cb.id = 'kcDmCb';

    /* Same tick mark as the TF row -- cloned rather than re-drawn so the two
       rows cannot drift if snippets/kc3-icon.liquid changes. */
    var check = document.createElement('span');
    check.className = 'check';
    var src = root.querySelector('#addon .check svg');
    if (src) check.appendChild(src.cloneNode(true));

    var img = document.createElement('img');
    img.src = ADDIN.img; img.alt = ''; img.loading = 'lazy';

    var t = document.createElement('span');
    t.className = 'addon__t';
    var b = document.createElement('b');
    b.textContent = ADDIN.label;
    t.appendChild(b);

    /* Same convention as the tier tiles: show what they will pay, with the
       undiscounted price struck through. Like the tiles this is display-only
       -- the cart posts the real variant and a discount takes it down, so the
       two must be kept in step by hand. See cro/AOV-PLAN-2026-09-22.md. */
    var p = document.createElement('span');
    p.className = 'addon__p';
    var was = document.createElement('s');
    was.textContent = moneyDown(ADDIN.list);
    p.appendChild(was);
    /* "from": this is the 8% floor. More devices in the cart take it lower. */
    var from = document.createElement('i');
    from.className = 'kc3-addon__from';
    from.textContent = 'from';
    p.appendChild(from);
    p.appendChild(document.createTextNode(' +' + moneyDown(ADDIN.pay)));

    label.appendChild(cb); label.appendChild(check); label.appendChild(img);
    label.appendChild(t); label.appendChild(p);

    cb.addEventListener('change', function () {
      label.classList.toggle('is-on', cb.checked);
      applyAddin(root);
    });

    if (afterEl && afterEl.parentNode === wrap) wrap.insertBefore(label, afterEl.nextSibling);
    else wrap.appendChild(label);
  }

  /* #5 of the 2026-09-22 brief. Figures are the merchant's; keep them true.
     The stars and the truck come from nodes the theme already rendered, so
     they match the rest of the page and survive an icon change. */
  var TRUST = {
    reviews: '(1,245 Reviews)',
    trusted: 'Trusted by 70,000+ KeldCo customers',
    badges: [
      { text: 'FREE Shipping', solid: true, truck: true },
      { text: '12-Month Warranty', icon: 'shield' },
      { text: '30-Day Money-Back', icon: 'back' },
      /* No icon: Afterpay's wordmark is a trademark and no copy of it exists
         anywhere on this site, so nothing is drawn from memory. Drop their
         official asset in here when you have it. */
      { text: 'Afterpay Available' }
    ]
  };

  /* `order` on the surviving cards needs the list to be a flex/grid container;
     .buy__hl is already a grid, so this costs nothing. */

  /* Drawn to match the theme's own icons: 24 box, no fill, 2px round strokes
     inheriting the badge's colour. */
  var ICON_PATHS = {
    shield: ['M12 3.2l7 2.9v4.9c0 4.3-2.9 8.2-7 9.8-4.1-1.6-7-5.5-7-9.8V6.1l7-2.9z',
             'M9.1 12.1l2.1 2.1 3.8-4'],
    back:   ['M3.6 12a8.4 8.4 0 1 0 2.5-6', 'M3.1 4.7v5h5']
  };

  function svgIcon(name) {
    var paths = ICON_PATHS[name];
    if (!paths) return null;
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    paths.forEach(function (d) {
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', d);
      svg.appendChild(p);
    });
    return svg;
  }


  /* ----------------------------------------------------------------------
     Gallery badges: a social-proof pill top-left, a rank pill top-right.

     "70,000+ Customers" is the figure the site already uses -- the trust line
     under the button says "Trusted by 70,000+ KeldCo customers" and the home
     page counter reads 72,586+. It is deliberately the rounded-down one.

     RANK IS PER PRODUCT ON PURPOSE. Over the last 7 days the Solar Cam Pro 3.0
     sold 406 units against 27 for the next best, so "#1 Best Seller" is true
     there and nowhere else. The other four carry a claim that is true for them.
     To make every page read "#1 Best Seller", set RANK_ALL below to that
     string; leave it null to use the per-product table.
     ---------------------------------------------------------------------- */
  var RANK_ALL = null;
  var CUSTOMERS = '70,000+ Customers';
  var CUSTOMERS_LEAD = 'LOVED BY OVER';
  var RANKS = [
    [/solar camera pro 3/i, '#1 Best Seller'],
    [/doormate/i,           '#1 Doorbell Cam'],
    [/home guardian/i,      '#1 Indoor Cam'],
    [/lumis/i,              'Just Launched'],
    [/\b4g\b/i,             'No Wi-Fi Needed']
  ];

  function rankFor(title) {
    if (RANK_ALL) return RANK_ALL;
    for (var i = 0; i < RANKS.length; i++) {
      if (RANKS[i][0].test(title)) return RANKS[i][1];
    }
    return null;
  }

  function heartIcon() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    var pth = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    /* Solid, unlike the outlined icons on the trust row -- it sits reversed
       out of a dark disc, where a 2px stroke would disappear at this size. */
    pth.setAttribute('d', 'M12 21s-7.5-4.7-9.3-9A5.2 5.2 0 0 1 12 6.6a5.2 5.2 0 0 1 9.3 5.4C19.5 16.3 12 21 12 21z');
    pth.setAttribute('fill', 'currentColor');
    svg.appendChild(pth);
    return svg;
  }

  function buildBadges(root) {
    var frame = root.querySelector('.gallery__main');
    if (!frame || frame.querySelector('.kc3-gb')) return;

    var buy = root.querySelector('.kc3-buy');
    var title = (buy && buy.dataset.productTitle) || '';

    var wrap = document.createElement('div');
    wrap.className = 'kc3-gb';

    var left = document.createElement('span');
    left.className = 'kc3-gb__pill kc3-gb__pill--proof';
    var disc = document.createElement('span');
    disc.className = 'kc3-gb__disc';
    disc.appendChild(heartIcon());
    var txt = document.createElement('span');
    txt.className = 'kc3-gb__txt';
    var lead = document.createElement('small');
    lead.textContent = CUSTOMERS_LEAD;
    var big = document.createElement('b');
    big.textContent = CUSTOMERS;
    txt.appendChild(lead); txt.appendChild(big);
    left.appendChild(disc); left.appendChild(txt);
    wrap.appendChild(left);

    var rank = rankFor(title);
    if (rank) {
      var right = document.createElement('span');
      right.className = 'kc3-gb__pill kc3-gb__pill--rank';
      right.textContent = rank;
      wrap.appendChild(right);
    }

    frame.appendChild(wrap);
    /* The section draws its own .gallery__badge in this exact corner. Its text
       is carried by the rank pill on every product that has one -- "New . 3.0"
       and "New Product" are both weaker than the rank, "Launch sale" is not a
       sale we are running, and the 4G's "4G . No Wi-Fi needed" IS the rank.
       The class goes on here rather than the rule being unconditional, so a
       failure in this function leaves the original badge showing. */
    frame.classList.add('kc3-gb-on');
  }

  function buildTrust(root) {
    var buy = root.querySelector('.kc3-buy');
    if (!buy || root.querySelector('.kc3-trust')) return;

    /* Where the shipping/assurance block used to sit: straight under the
       buttons. */
    var anchor = root.querySelector('.buy__promise')
      || root.querySelector('#ctaError')
      || root.querySelector('.buy__express')
      || root.querySelector('.buy__cta-row');
    if (!anchor || anchor.parentNode !== buy) return;

    var box = document.createElement('div');
    box.className = 'kc3-trust';

    var line = document.createElement('div');
    line.className = 'kc3-trust__line';
    var stars = root.querySelector('.buy__rating .stars');
    if (stars) {
      var s = stars.cloneNode(true);
      s.classList.remove('stars--lg');
      line.appendChild(s);
    }
    line.appendChild(document.createTextNode(TRUST.reviews));
    var sep = document.createElement('i');
    sep.textContent = '|';
    line.appendChild(sep);
    var strong = document.createElement('b');
    strong.textContent = TRUST.trusted;
    line.appendChild(strong);
    box.appendChild(line);

    var truckSrc = root.querySelector('.buy__promise svg');
    var ul = document.createElement('ul');
    ul.className = 'kc3-trust__badges';
    TRUST.badges.forEach(function (bd) {
      var li = document.createElement('li');
      if (bd.solid) li.className = 'is-solid';
      if (bd.truck && truckSrc) li.appendChild(truckSrc.cloneNode(true));
      else if (bd.icon) { var ic = svgIcon(bd.icon); if (ic) li.appendChild(ic); }
      li.appendChild(document.createTextNode(bd.text));
      ul.appendChild(li);
    });
    box.appendChild(ul);

    buy.insertBefore(box, anchor);
  }

  /* " (8%)". Floored, like the dollars, so the badge can never claim a
     deeper discount than the ladder actually gives. */
  function pctSuffix(t) {
    if (!(t.was > 0) || !(t.save > 0)) return '';
    var pct = Math.floor((t.save / t.was) * 100);
    return pct > 0 ? ' (' + pct + '%)' : '';
  }

  /* Three cards, not eight. They answer the only three questions each price
     raises, in the order they are asked. Warranty, support and shipping are
     deliberately absent -- they are already on the trust pills directly under
     the button, and repeating them up here only pushed the button down.

     Every claim traces to a highlight block in the product's own template.
     Nothing here asserts anything the theme did not already assert, and Ring
     and Arlo are NOT named: the section schema restricts that comparison to
     the lander.

     Keyed on the product title, which the section writes to
     .kc3-buy[data-product-title]. A product with no entry here falls through
     to KEEP its first three highlights untouched -- see buildFeatures. That
     fallback matters: an earlier cut removed every highlight it did not
     recognise, which would have emptied this section on every product except
     the Solar Cam. */
  var FEATURE_SETS = [
    { match: /solar camera pro 3/i, cards: [
      [/no subscription/i, '$0 a month, forever',
        'Record, watch and keep your footage with no subscription. Every feature unlocked from day one.'],
      [/3k crystal/i, '3K video with smart alerts',
        'Spots people, cars and packages. Talk through the camera or set off the alarm \u2014 all from our own KeldCo app.'],
      [/5-minute setup/i, 'Up in 5 minutes',
        'Solar powered, so no electrician and no wiring. Put it anywhere sunny and never charge it again.']
    ]},
    { match: /doormate/i, cards: [
      [/no subscription/i, '$0 a month, forever',
        'Record, watch and keep your footage with no subscription. Every feature unlocked from day one.'],
      [/phone rings/i, 'Rings your phone, wherever you are',
        'Press the bell and your phone rings \u2014 see, hear and talk to whoever is there, whether you are upstairs or overseas. Indoor chime in the box.'],
      [/six months per charge/i, '2K, 160\u00b0, six months per charge',
        'Head to toe in 2K, day or night, rain or shine \u2014 and six months between charges.']
    ]},
    { match: /home guardian/i, cards: [
      [/no subscription/i, '$0 a month, forever',
        'Record, watch and keep your footage with no subscription. Every feature unlocked from day one.'],
      [/privacy mode/i, 'Privacy mode, built in',
        'One tap parks the lens facing down when you are home. Record 24/7 to your own card, not the cloud.'],
      [/4mp qhd/i, '4MP QHD, not 1080p',
        '360\u00b0 pan and tilt with smart human tracking, so it follows the room.']
    ]},
    /* 4G is the one product where "$0 a month, forever" would be FALSE: it
       needs a data SIM the customer buys themselves. Card 1 therefore claims
       only what is true -- no app fees and no storage fees from us -- and
       says who supplies the SIM. Do not copy the SC3 card onto this product. */
    { match: /\b4g\b/i, cards: [
      [/works where wi-?fi/i, 'Works where Wi-Fi can\'t reach',
        'Runs on the Australian 4G network \u2014 sheds, gates, paddocks, building sites. Takes any data SIM, not included.'],
      [/no app fees/i, 'No app fees, no storage fees',
        'Every feature unlocked from day one, and your footage records to a card you own. We never charge you to watch it.'],
      [/solar powered/i, 'Solar powered, up in 3 minutes',
        'The sun keeps it charged. No wiring, no power point, no electrician and no battery swaps.']
    ]},
    { match: /lumis/i, cards: [
      [/no subscription/i, '$0 a month, forever',
        'Record, watch and keep your footage with no subscription. Every feature unlocked from day one.'],
      [/records 24\/7/i, 'Records 24/7, not 30-second clips',
        'Round-the-clock to your own card, up to 256GB \u2014 and 3K in full colour after dark, not grey.'],
      [/floodlight wiring/i, '2,600 lumens, wired in 15 minutes',
        'Twin floodlights snap to daylight. Swaps onto the floodlight wiring you already have.']
    ]}
  ];

  function featureCardsFor(root) {
    var buy = root.querySelector('.kc3-buy');
    var title = (buy && buy.dataset.productTitle) || document.title || '';
    for (var i = 0; i < FEATURE_SETS.length; i++) {
      if (FEATURE_SETS[i].match.test(title)) return FEATURE_SETS[i].cards;
    }
    return null;
  }

  function buildFeatures(root) {
    var list = root.querySelector('.buy__hl');
    if (!list || list.dataset.kcDone) return;
    list.dataset.kcDone = '1';

    var cards = featureCardsFor(root);
    var lis = [].slice.call(list.querySelectorAll('li'));

    /* Unknown product: keep the first three highlights as they are, trimmed to
       a label plus their own sentence. Never leave the section empty. */
    if (!cards) {
      lis.forEach(function (li, i) {
        if (i > 2) { li.parentNode.removeChild(li); return; }
        var bEl = li.querySelector('b');
        var lead = bEl ? (bEl.textContent || '').trim().replace(/\.$/, '') : '';
        var span = li.querySelector('span');
        var body = span ? (span.textContent || '').replace(bEl ? bEl.textContent : '', '').trim() : '';
        paint(li, lead, body, i);
      });
      return;
    }

    lis.forEach(function (li) {
      var bEl = li.querySelector('b');
      var lead = bEl ? (bEl.textContent || '').trim() : '';
      var rank = -1, card = null;
      for (var i = 0; i < cards.length; i++) {
        if (cards[i][0].test(lead)) { card = cards[i]; rank = i; break; }
      }
      if (!card) { li.parentNode.removeChild(li); return; }
      paint(li, card[1], card[2], rank);
    });
  }

  function paint(li, label, body, rank) {
    var icon = li.querySelector('svg');
    var badge = document.createElement('span');
    badge.className = 'kc3-feat__badge';
    if (icon) badge.appendChild(icon.cloneNode(true));
    var strong = document.createElement('b');
    strong.textContent = label;
    badge.appendChild(strong);

    var p = document.createElement('span');
    p.className = 'kc3-feat__body';
    p.textContent = body;

    li.textContent = '';
    li.style.order = String(rank);
    li.appendChild(badge);
    if (body) li.appendChild(p);
  }

  /* `order` on the surviving cards needs the list to be a flex/grid container;
     .buy__hl is already a grid, so this costs nothing. */

  /* Drawn to match the theme's own icons: 24 box, no fill, 2px round strokes
     inheriting the badge's colour. */
  var ICON_PATHS = {
    shield: ['M12 3.2l7 2.9v4.9c0 4.3-2.9 8.2-7 9.8-4.1-1.6-7-5.5-7-9.8V6.1l7-2.9z',
             'M9.1 12.1l2.1 2.1 3.8-4'],
    back:   ['M3.6 12a8.4 8.4 0 1 0 2.5-6', 'M3.1 4.7v5h5']
  };

  function svgIcon(name) {
    var paths = ICON_PATHS[name];
    if (!paths) return null;
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    paths.forEach(function (d) {
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', d);
      svg.appendChild(p);
    });
    return svg;
  }

  /* " (8%)". Floored, like the dollars, so the badge can never claim a
     deeper discount than the ladder actually gives. */
  function pctSuffix(t) {
    if (!(t.was > 0) || !(t.save > 0)) return '';
    var pct = Math.floor((t.save / t.was) * 100);
    return pct > 0 ? ' (' + pct + '%)' : '';
  }

  function readData(root) {
    var el = root.querySelector('#kc3-buybox-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* ---- tiers ------------------------------------------------------------ */

  function decorateTiles(root, tiers) {
    var wrap = root.querySelector('#tiers');
    if (!wrap) return;

    var tiles = wrap.querySelectorAll('.tier');
    if (!tiles.length || tiers.length !== tiles.length) return;
    wrap.classList.toggle('kc3-odd', tiles.length % 2 === 1);

    /* Relocate only "Most popular". Any other tag a product sets -- DoorMate
       uses "Best value" on 6+ -- is left exactly where it is. */
    var promoteTo = -1;
    if (PROMOTE_Q) {
      for (var i = 0; i < tiers.length; i++) {
        if (tiers[i].q === PROMOTE_Q) promoteTo = i;
      }
    }

    tiers.forEach(function (t, i) {
      var tile = tiles[i];
      if (tile.dataset.kcDone) return;
      tile.dataset.kcDone = '1';

      var tagEl = tile.querySelector('.tier__tag');
      if (promoteTo !== -1 && tagEl) {
        if (/most popular/i.test(tagEl.textContent || '') && i !== promoteTo) {
          tagEl.innerHTML = '';
        }
        if (i === promoteTo && !(tagEl.textContent || '').trim()) {
          tagEl.innerHTML = '<b>Most popular</b>';
        }
      }

      /* kc3.js writes "$641.56 total". Rewritten from the tiers JSON rather
         than parsed back out of that string, because the cents have to go and
         the figure has to round the right way. */
      var total = tile.querySelector('.tier__total');
      if (total && typeof t.total === 'number') {
        total.textContent = moneyUp(t.total);
        total.classList.remove('is-none');
      }

      if (!tile.querySelector('.tier__save')) {
        var s = document.createElement('span');
        s.className = 'tier__save' + (t.save > 0 ? '' : ' is-none');
        s.textContent = 'Save ' + moneyDown(t.save) + pctSuffix(t);
        if (total && total.parentNode) total.parentNode.insertBefore(s, total.nextSibling);
        else tile.appendChild(s);
      }
    });

    /* kc3.js owns this list and rebuilds it on its own schedule. Watching for
       replaced children is cheaper and more reliable than guessing when. */
    if (!wrap.dataset.kcWatched) {
      wrap.dataset.kcWatched = '1';
      try {
        new MutationObserver(function () { run(); })
          .observe(wrap, { childList: true });
      } catch (e) { /* no observer, the timed passes below still cover it */ }
    }
  }

  /* ---- heading ---------------------------------------------------------- */

  function decorateHeading(root, tiers) {
    var wrap = root.querySelector('#tiers');
    var head = wrap && wrap.previousElementSibling;
    if (!head || !head.classList.contains('buy__label')) return;
    if (head.dataset.kcDone) return;
    head.dataset.kcDone = '1';
    head.classList.add('kc3-tier-head');

    /* Only the default wording, "How many cameras?" and its siblings on the
       other three products. A merchant-set label is left alone. */
    var first = head.firstChild;
    if (first && first.nodeType === 3 && /^\s*how many\b/i.test(first.nodeValue)) {
      first.nodeValue = TIER_LABEL + ' ';
    }

    var hint = head.querySelector('span');
    if (hint && /^\s*buy more, save more\s*$/i.test(hint.textContent || '')) {
      var best = 0;
      tiers.forEach(function (t) { if (t.save > best) best = t.save; });
      /* The figure is read from the ladder so it cannot drift from the tiles.
         The scarcity half of the line is the merchant's call, signed off
         2026-09-22; keep it in step with what stock can actually support. */
      hint.textContent = best > 0
        ? 'Save up to ' + moneyDown(best) + ' \u2014 get in before they\'re gone'
        : 'Get in before they\'re gone';
    }
  }

  /* ---- add-on ----------------------------------------------------------- */

  function decorateAddon(root) {
    var addon = root.querySelector('#addon');
    var wrap = addon && addon.parentNode;
    if (!addon || !wrap || wrap.dataset.kcDone) return;
    wrap.dataset.kcDone = '1';

    var title = addon.querySelector('.addon__t b');
    if (title && /^\s*add micro tf cards\s*$/i.test(title.textContent || '')) {
      title.textContent = ADDON_TITLE;
    }

    /* The benefit line is the longest thing in the row and the least useful
       there. Out of the row, into a ribbon behind the card. */
    var benefit = addon.querySelector('.addon__t span');
    var text = benefit && (benefit.textContent || '').trim();
    if (benefit) benefit.parentNode.removeChild(benefit);

    var head = document.createElement('div');
    head.className = 'kc3-addon-head';
    head.appendChild(document.createTextNode(ADDON_HEAD));
    wrap.insertBefore(head, addon);

    if (text) {
      var ribbon = document.createElement('div');
      ribbon.className = 'kc3-addon-ribbon';
      ribbon.textContent = text;
      wrap.insertBefore(ribbon, addon);
    }

    /* Under the TF card and its size panel, not between them. Which product
       is offered is decided by ADDIN_FOR above, not here. */
    var buyEl = root.querySelector('.kc3-buy');
    var ptitle = (buyEl && buyEl.dataset.productTitle) || '';
    ADDIN = addinFor(ptitle);

    var anchor = wrap.querySelector('#tfSizes') || addon;
    if (ADDIN) buildAddin(root, wrap, anchor);
    var dm = root.querySelector('#kcDm');
    if (dm && !wrap.querySelector('.kc3-addon-ribbon--dm')) {
      var r = document.createElement('div');
      r.className = 'kc3-addon-ribbon kc3-addon-ribbon--dm';
      r.textContent = 'Save '
        + Math.floor(((ADDIN.list - ADDIN.pay) / ADDIN.list) * 100)
        + '% or more';
      wrap.insertBefore(r, dm);
    }
  }

  /* ---- ------------------------------------------------------------------ */

  function decorate(root) {
    var data = readData(root);
    var tiers = (data && data.tiers) || [];
    if (tiers.length) {
      decorateTiles(root, tiers);
      decorateHeading(root, tiers);
    }
    decorateAddon(root);
    buildFeatures(root);
    buildTrust(root);
    buildBadges(root);
  }

  function run() {
    document.querySelectorAll('#s-main').forEach(function (root) {
      try { decorate(root); } catch (e) { /* display-only: never block the page */ }
    });
  }

  /* kc3.js has just republished the total and the cart lines; take its number
     as the base, then re-apply ours on top. */
  document.addEventListener('kc3:selection', function () {
    var root = document.querySelector('#s-main');
    if (!root) return;
    var amtEl = root.querySelector('#ctaAmt');
    var base = parseAmt(amtEl && amtEl.textContent);
    if (base !== null) dmBase = base;
    try { applyAddin(root); } catch (e) { /* never block the cart */ }
  });

  document.addEventListener('kc3:ready', run);
  document.addEventListener('shopify:section:load', run);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 0); });
  } else {
    setTimeout(run, 0);
  }
  /* kc3.js renders the tiles on its own schedule; if kc3:ready has already
     fired or never fires, these late passes still catch them. */
  setTimeout(run, 600);
  setTimeout(run, 2500);

  /* The price block is hidden because the tiles carry the price now. If the
     tiles never arrive the page would have no price on it at all, so put the
     original block back rather than leave it priceless. */
  setTimeout(function () {
    if (!document.querySelector('#tiers .tier')) {
      document.documentElement.classList.add('kc3-tiers-missing');
    }
  }, 3000);
}());
